import React from 'react'

import { IframeAppInstance } from 'shared/types/index'

export interface AppIconProps {
  app: IframeAppInstance
  className?: string
  width?: number
  height?: number
  alt?: string
}

export const AppIcon: React.FC<AppIconProps> = ({
  app,
  className,
  width = 24,
  height = 24,
  alt
}) => {
  if (!app.icon) return null

  return (
    <img
      src={app.icon}
      alt={alt || app.name}
      className={className}
      width={width}
      height={height}
    />
  )
}
